import { Grid } from 'antd';
import { ReactNode, useState } from 'react';
import {
  CorporateReportInfoBanner,
  ReportLegendItem
} from './CorporateReportInfoBanner';
import { CorporateReportLegendSidebar } from './CorporateReportLegendSidebar';

interface CorporateReportShellProps {
  description: string;
  legendItems?: ReportLegendItem[];
  children: ReactNode;
}

export const CorporateReportShell = ({
  description,
  legendItems = [],
  children
}: CorporateReportShellProps) => {
  const [legendOpen, setLegendOpen] = useState(false);
  const hasLegend = legendItems.length > 0;
  const screens = Grid.useBreakpoint();
  const isDesktop = !!screens.md;

  return (
    <div className="flex flex-col gap-3">
      <CorporateReportInfoBanner
        description={description}
        legendOpen={legendOpen}
        showLegendToggle={hasLegend}
        onToggleLegend={() => setLegendOpen(open => !open)}
      />

      {hasLegend && legendOpen && !isDesktop && (
        <CorporateReportLegendSidebar items={legendItems} fullWidth />
      )}

      <div className="flex flex-col items-stretch gap-4 lg:flex-row lg:items-start">
        <div className="min-w-0 flex-1">{children}</div>

        {hasLegend && legendOpen && isDesktop && (
          <CorporateReportLegendSidebar items={legendItems} />
        )}
      </div>
    </div>
  );
};

export type { ReportLegendItem };
